<template>
    <div
        :id="item.id"
        :aria-labelledby="`${item.id}-tab`"
        class="tab-pane fade"
        role="tabpanel"
    >
        <section class="fraci-panel">
            <FormTabHeader icon="fal fa-users" :title="item.name" />
            <div class="fraci-body">
                <div v-if="form.racis && form.racis.length > 0" class="fr-grid">
            <!-- Responsable -->
            <div class="fr-role-card">
                <div class="fr-role-header">
                    <div class="fr-role-badge" style="background: rgba(59, 130, 246, 0.1); color: #3b82f6;">
                        <i class="fal fa-user-check"></i>
                    </div>
                    <div>
                        <span class="fr-role-name">Responsable</span>
                        <span class="fr-role-count">{{ responsible.length }}</span>
                    </div>
                </div>
                <div class="fr-role-users">
                    <div v-if="responsible.length === 0" class="fr-empty">Aucun</div>
                    <div v-for="user in responsible" :key="'r-' + user.id" class="fr-user">
                        <div class="fr-avatar">{{ getInitials(user.name) }}</div>
                        <div class="fr-user-info">
                            <span class="fr-user-name">{{ user.name }}</span>
                            <span v-if="user.email" class="fr-user-email">{{ user.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Acteur -->
            <div class="fr-role-card">
                <div class="fr-role-header">
                    <div class="fr-role-badge" style="background: rgba(16, 185, 129, 0.1); color: #10b981;">
                        <i class="fal fa-user-shield"></i>
                    </div>
                    <div>
                        <span class="fr-role-name">Acteur</span>
                        <span class="fr-role-count">{{ accountable.length }}</span>
                    </div>
                </div>
                <div class="fr-role-users">
                    <div v-if="accountable.length === 0" class="fr-empty">Aucun</div>
                    <div v-for="user in accountable" :key="'a-' + user.id" class="fr-user">
                        <div class="fr-avatar" style="background: rgba(16, 185, 129, 0.1); color: #10b981;">{{ getInitials(user.name) }}</div>
                        <div class="fr-user-info">
                            <span class="fr-user-name">{{ user.name }}</span>
                            <span v-if="user.email" class="fr-user-email">{{ user.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Contributeurs -->
            <div class="fr-role-card">
                <div class="fr-role-header">
                    <div class="fr-role-badge" style="background: rgba(245, 158, 11, 0.1); color: #f59e0b;">
                        <i class="fal fa-users"></i>
                    </div>
                    <div>
                        <span class="fr-role-name">Contributeurs</span>
                        <span class="fr-role-count">{{ consulted.length }}</span>
                    </div>
                </div>
                <div class="fr-role-users">
                    <div v-if="consulted.length === 0" class="fr-empty">Aucun</div>
                    <div v-for="user in consulted" :key="'c-' + user.id" class="fr-user">
                        <div class="fr-avatar" style="background: rgba(245, 158, 11, 0.1); color: #f59e0b;">{{ getInitials(user.name) }}</div>
                        <div class="fr-user-info">
                            <span class="fr-user-name">{{ user.name }}</span>
                            <span v-if="user.email" class="fr-user-email">{{ user.email }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Informés -->
            <div class="fr-role-card">
                <div class="fr-role-header">
                    <div class="fr-role-badge" style="background: rgba(139, 92, 246, 0.1); color: #8b5cf6;">
                        <i class="fal fa-bell"></i>
                    </div>
                    <div>
                        <span class="fr-role-name">Informés</span>
                        <span class="fr-role-count">{{ informed.length }}</span>
                    </div>
                </div>
                <div class="fr-role-users">
                    <div v-if="informed.length === 0" class="fr-empty">Aucun</div>
                    <div v-for="user in informed" :key="'i-' + user.id" class="fr-user">
                        <div class="fr-avatar" style="background: rgba(139, 92, 246, 0.1); color: #8b5cf6;">{{ getInitials(user.name) }}</div>
                        <div class="fr-user-info">
                            <span class="fr-user-name">{{ user.name }}</span>
                            <span v-if="user.email" class="fr-user-email">{{ user.email }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

                <div v-else class="fr-empty-state">
                    <i class="fal fa-users"></i>
                    <p>Aucun responsable pour le moment</p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import FormMixin from './FormMixin'
import FormTabHeader from './FormTabHeader'
import { mapState } from 'vuex'

export default {
    name: 'FormRaci',
    mixins: [FormMixin],
    components: { FormTabHeader },
    props: ['item'],
    data() {
        return {
            responsible: [],
            accountable: [],
            consulted: [],
            informed: []
        }
    },
    computed: {
        ...mapState('form', {
            form: (state) => state.form
        })
    },
    created() {
        if (this.form.racis) {
            this.form.racis.forEach((user) => {
                if (user.is_responsible) this.responsible.push(user)
                if (user.is_accountable) this.accountable.push(user)
                if (user.is_consulted) this.consulted.push(user)
                if (user.is_informed) this.informed.push(user)
            })
        }
    },
    methods: {
        getInitials(name) {
            if (!name) return '?'
            return name.split(' ').map((w) => w[0]).slice(0, 2).join('').toUpperCase()
        }
    }
}
</script>

<style scoped>
.fraci-panel {
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
    overflow: hidden;
    margin-top: var(--v2-space-5);
}

.fraci-body {
    padding: var(--v2-space-5);
}

.fr-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
}

.fr-role-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    overflow: hidden;
    transition: border-color 0.2s;
}

.fr-role-card:hover {
    border-color: #bfdbfe;
}

.fr-role-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 18px;
    background: #f8fafc;
    border-bottom: 1px solid #f1f5f9;
}

.fr-role-badge {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 0.9rem;
}

.fr-role-name {
    font-size: 0.88rem;
    font-weight: 600;
    color: #0f172a;
    display: block;
}

.fr-role-count {
    font-size: 0.72rem;
    color: #94a3b8;
}

.fr-role-users {
    padding: 8px 0;
}

.fr-user {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 18px;
    transition: background 0.15s;
}

.fr-user:hover {
    background: #f8fafc;
}

.fr-avatar {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
    font-size: 0.72rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.fr-user-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.fr-user-name {
    font-size: 0.84rem;
    font-weight: 600;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fr-user-email {
    font-size: 0.75rem;
    color: #94a3b8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.fr-empty {
    padding: 16px 18px;
    font-size: 0.82rem;
    color: #94a3b8;
    text-align: center;
}

.fr-empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 0;
    color: #94a3b8;
}

.fr-empty-state i {
    font-size: 2.5rem;
    margin-bottom: 12px;
}

.fr-empty-state p {
    font-size: 0.88rem;
}

@media (max-width: 768px) {
    .fr-grid {
        grid-template-columns: 1fr;
    }
}
</style>
